import { Currency, CurrencyOld } from 'types';

export const isSwissOrEuroCurrency = (currency: Currency | CurrencyOld | string) =>
  [CurrencyOld.CHF, CurrencyOld.EUR].includes(currency as CurrencyOld);
